import idris from "refractor/idris";
export default idris;